import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { NHANXETHOIDONG_API } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue, thoiGianDanhGiaValue } from '../../../../utils/define';
import moment from 'moment';

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600 }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const NhanXetHoiDongForm = ({ baoVeCapVienId, readOnly = false, isUserView = false, onDataLoaded, onSaveSuccess }) => {
    const [saving, setSaving] = useState(false);
    
    const [nhanXetHoiDongId, setNhanXetHoiDongId] = useState(null);
    const [ketQua, setKetQua] = useState(loaiDanhGiaValue.dat);
    const [soBanNhanXet, setSoBanNhanXet] = useState('');
    const [ngayNhanXetMuon, setNgayNhanXetMuon] = useState('');
    const [lucDanhGia, setLucDanhGia] = useState(thoiGianDanhGiaValue.truoc);
    const [isKetQuaDatDuoc, setIsKetQuaDatDuoc] = useState(true);
    const [isNeuBatMoi, setIsNeuBatMoi] = useState(true);

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['nhanXetHoiDongData', baoVeCapVienId], 
        () => Get(`${NHANXETHOIDONG_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setNhanXetHoiDongId(item.id);
                setKetQua(item.ketQua || loaiDanhGiaValue.dat);
                setSoBanNhanXet(item.soBanNhanXet || '');
                setNgayNhanXetMuon(item.ngayNhanXetMuon ? moment(item.ngayNhanXetMuon).format('YYYY-MM-DD') : '');
                setLucDanhGia(item.lucDanhGia || thoiGianDanhGiaValue.truoc);
                
                if (item.isKetQuaDatDuoc !== undefined && item.isKetQuaDatDuoc !== null) {
                    setIsKetQuaDatDuoc(item.isKetQuaDatDuoc);
                }
                
                if (item.isNeuBatMoi !== undefined && item.isNeuBatMoi !== null) {
                    setIsNeuBatMoi(item.isNeuBatMoi);
                }
                
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                KetQua: ketQua,
                SoBanNhanXet: soBanNhanXet ? parseInt(soBanNhanXet) : null,
                NgayNhanXetMuon: ngayNhanXetMuon || null,
                LucDanhGia: lucDanhGia,
                IsKetQuaDatDuoc: isKetQuaDatDuoc,
                IsNeuBatMoi: isNeuBatMoi
            };

            if (nhanXetHoiDongId) {
                await Put(NHANXETHOIDONG_API.UPDATE_ITEM, nhanXetHoiDongId, { ...payload, Id: nhanXetHoiDongId });
            } else {
                await Post(NHANXETHOIDONG_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thông tin chung</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Kết quả</>} value={ketQua === loaiDanhGiaValue.dat ? 'Đạt' : 'Không đạt'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Đạt"
                                            name="ketQuaNhanXet"
                                            checked={ketQua === loaiDanhGiaValue.dat}
                                            onChange={() => setKetQua(loaiDanhGiaValue.dat)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không đạt"
                                            name="ketQuaNhanXet"
                                            checked={ketQua === loaiDanhGiaValue.khongDat}
                                            onChange={() => setKetQua(loaiDanhGiaValue.khongDat)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Nhận xét của thành viên trong Hội đồng</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Số bản nhận xét của thành viên Hội đồng</>} value={soBanNhanXet} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Số bản nhận xét của thành viên Hội đồng</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soBanNhanXet}
                                        onChange={(e) => setSoBanNhanXet(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số bản nhận xét..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Ngày viết nhận xét bản muộn nhất</>} value={ngayNhanXetMuon ? moment(ngayNhanXetMuon).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Ngày viết nhận xét bản muộn nhất</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayNhanXetMuon}
                                        onChange={(e) => setNgayNhanXetMuon(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Thời gian đánh giá</>} value={lucDanhGia === thoiGianDanhGiaValue.truoc ? 'Trước ngày bảo vệ' : 'Sau ngày bảo vệ'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Thời gian đánh giá</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Trước ngày bảo vệ"
                                            name="lucDanhGia"
                                            checked={lucDanhGia === thoiGianDanhGiaValue.truoc}
                                            onChange={() => setLucDanhGia(thoiGianDanhGiaValue.truoc)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Sau ngày bảo vệ"
                                            name="lucDanhGia"
                                            checked={lucDanhGia === thoiGianDanhGiaValue.sau}
                                            onChange={() => setLucDanhGia(thoiGianDanhGiaValue.sau)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">3. Nội dung các văn bản nhận xét luận án</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Đánh giá về nội dung, phương pháp, kết quả, ý nghĩa, độ tin cậy của các kết quả đạt được</>} value={isKetQuaDatDuoc ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Đánh giá về nội dung, phương pháp, kết quả, ý nghĩa, độ tin cậy của các kết quả đạt được</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isKetQuaDatDuoc"
                                            checked={isKetQuaDatDuoc === true}
                                            onChange={() => setIsKetQuaDatDuoc(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isKetQuaDatDuoc"
                                            checked={isKetQuaDatDuoc === false}
                                            onChange={() => setIsKetQuaDatDuoc(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Nêu bật được những luận điểm mới của luận án</>} value={isNeuBatMoi ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Nêu bật được những luận điểm mới của luận án</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isNeuBatMoi"
                                            checked={isNeuBatMoi === true}
                                            onChange={() => setIsNeuBatMoi(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isNeuBatMoi"
                                            checked={isNeuBatMoi === false}
                                            onChange={() => setIsNeuBatMoi(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default NhanXetHoiDongForm;
